<template>
    <div>
        <div class="col-lg-12">
            <div>
                <!-- <Draggable
                    :list="varForm.blocks_settings"
                    handle=".handle"
                    ghost-class="ghost--eventPrize"
                    @start="dragList = true"
                    @end="dragList = false"
                >
                  
                </Draggable> -->
                <div v-for="(blockItem, idx) in varForm.blocks_settings" :key="idx" class="mb-3">
                    <div class="row">
                        <div>
                            <InputCheckBox
                                v-if="blockItem?.block_default"
                                class="custom-switch text-right"
                                :model.sync="blockItem.is_visibled"
                                :id="`checks-switch-${idx}`"
                                :value="blockItem.is_visibled"
                                :label="``"
                            />
                        </div>
                        <div class="col-sm-5">
                            <div class="d-flex">
                                <h5 class="col-sm-7 text-truncate">{{ blockItem.name }}</h5>
                                <button
                                    v-if="['free_blocks', 'button_blocks', 'header_information'].includes(blockItem.key)"
                                    type="button"
                                    class="btn btn-outline-warning btn-sm rounded-circle"
                                    style="width: 30px; height: 30px"
                                    @click="onHandleEditType(blockItem, idx)"
                                >
                                    <i class="fa fa-edit"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="isActivePopUpCondition(`${blockItem.key}-${idx}`)"
                        class="p-4 rounded my-3"
                        style="box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                    >
                        <ActionFreeBlock
                            v-if="blockItem.key === 'free_blocks'"
                            :objFree="objectFreeBlock"
                            :dataFreeBlock="varForm.free_blocks"
                            @cancel="onHandleCancel"
                            @save="onHandleSaveBlockFree"
                        />
                        <ActionButtonBlock
                            v-else-if="blockItem.key === 'button_blocks'"
                            :objButton="objectFreeBlock"
                            :dataButtonBlock="varForm.button_blocks"
                            @cancel="onHandleCancel"
                            @save="onHandleSaveButtonBlock"
                        />
                        <ActionHeadBlock
                            v-else-if="blockItem.key === 'header_information'"
                            :objHead="varForm.header_information"
                            @cancel="onHandleCancel"
                            @save="onHandleSaveHeadBlock"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import Draggable from 'vuedraggable';
import ActionFreeBlock from './components/action-free-block.vue';
import ActionButtonBlock from './components/action-button-block.vue';
import ActionHeadBlock from './components/action-head-block.vue';

import { InputCheckBox } from '@/components/Input';
import { cloneDeep } from 'lodash';

export default {
    name: 'SettingBlockLP',
    components: { InputCheckBox, ActionFreeBlock, ActionButtonBlock, ActionHeadBlock },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        }
    },

    data() {
        return {
            idEditBlock: null,
            objectFreeBlock: null,
            varForm: cloneDeep(this.dataForm)
        };
    },
    methods: {
        handleDeleteBlock(idx) {
            this.varForm.blocks_settings.splice(idx, 1);
        },

        isActivePopUpCondition(idActive) {
            return idActive === this.idEditBlock;
        },

        onHandleEditType(objB, idx) {
            this.objectFreeBlock = objB;
            if (this.idEditBlock === `${objB.key}-${idx}`) {
                this.idEditBlock = null;
            } else {
                this.idEditBlock = `${objB.key}-${idx}`;
            }
        },

        onHandleCancel() {
            this.idEditBlock = null;
        },

        onHandleSaveBlockFree(evtFree) {
            let { title, style, html_content, key_parent, size_title, color_title, background_title } = evtFree;
            this.idEditBlock = null;
            if (this.varForm.free_blocks?.length <= 0) {
                this.varForm.free_blocks.push(evtFree);
            } else {
                const foundFreeBlockEdit = this.varForm.free_blocks.find((otp) => otp.key_parent === key_parent);
                if (!foundFreeBlockEdit) {
                    this.varForm.free_blocks.push(evtFree);
                } else {
                    foundFreeBlockEdit.title = title;
                    foundFreeBlockEdit.style = style;
                    foundFreeBlockEdit.size_title = size_title;
                    foundFreeBlockEdit.color_title = color_title;
                    foundFreeBlockEdit.background_title = background_title;
                    foundFreeBlockEdit.html_content = html_content;
                    foundFreeBlockEdit.key_parent = key_parent;
                }
            }

            const foundObjFreeBlock = this.varForm.blocks_settings
                .filter((odt) => odt.key_parent === key_parent)
                .find((fdt) => fdt.key === 'free_blocks');
            foundObjFreeBlock.name = title;

            this.$emit('update:dataForm', this.varForm);
        },
        onHandleSaveButtonBlock(evtButton) {
            let { title_block, title_button, url, style, color, font_button, key_parent, html_content, background_color } = evtButton;
            this.idEditBlock = null;
            if (this.varForm.button_blocks?.length <= 0) {
                this.varForm.button_blocks.push(evtButton);
            } else {
                const foundButtonEdit = this.varForm.button_blocks.find((fbt) => fbt.key_parent === key_parent);
                if (!foundButtonEdit) {
                    this.varForm.button_blocks.push(evtButton);
                } else {
                    foundButtonEdit.title_block = title_block;
                    foundButtonEdit.title_button = title_button;
                    foundButtonEdit.url = url;
                    foundButtonEdit.style = style;
                    foundButtonEdit.color = color;
                    foundButtonEdit.background_color = background_color;
                    foundButtonEdit.font_button = font_button;
                    foundButtonEdit.key_parent = key_parent;
                    foundButtonEdit.html_content = html_content;
                }
            }
            const foundObjButtonBlock = this.varForm.blocks_settings
                .filter((odt) => odt.key_parent === key_parent)
                .find((fdt) => fdt.key === 'button_blocks');
            foundObjButtonBlock.name = title_block;

            this.$emit('update:dataForm', this.varForm);
        },

        onHandleSaveHeadBlock(evtHead) {
            this.idEditBlock = null;
            this.varForm.header_information = evtHead;
            this.$emit('update:dataForm', this.varForm);
        }
    },
    watch: {
        dataForm: {
            handler(newDataForm) {
                this.varForm = newDataForm;
            },
            immediate: true,
            deep: true
        },

        'varForm.blocks_settings': {
            handler() {
                this.$emit('update:dataForm', this.varForm);
            },
            deep: true
        }
    }
};
</script>

<style lang="scss"></style>
